var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyLorriesActive = function SvgMyLorriesActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.111 19.8h4.444V21a1 1 0 0 1-1 1H2.111a1 1 0 0 1-1-1v-1.2zM14.445 19.8h4.445V21a1 1 0 0 1-1 1h-2.445a1 1 0 0 1-1-1v-1.2z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.225 12.1h15.554V5.3a2 2 0 0 0-2-2H4.225a2 2 0 0 0-2 2v6.8zM3.52 9.9h12.962V6.5a1 1 0 0 0-1-1H4.52a1 1 0 0 0-1 1v3.4z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.111 4.4H1a1 1 0 0 0-1 1v2.4a1 1 0 0 0 1 1h.111V4.4zM20 7.8a1 1 0 0 1-1 1h-.11V4.4H19a1 1 0 0 1 1 1v2.4z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.946 0a2 2 0 0 1 2 2v.2H1.053V2a2 2 0 0 1 2-2h13.893zM0 11.9a2 2 0 0 1 2-2H18a2 2 0 0 1 2 2v5.8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-5.8zm6.666 2.3a1 1 0 0 1 1-1h4.666a1 1 0 0 1 1 1v3.4H6.666v-3.4zm9.99-2.1a1.1 1.1 0 1 0 0 2.2h1.132a1.1 1.1 0 0 0 0-2.2h-1.133zM1.11 13.2a1.1 1.1 0 0 1 1.1-1.1h1.133a1.1 1.1 0 0 1 0 2.2H2.211a1.1 1.1 0 0 1-1.1-1.1zm17.776 5.5v1.1H1.111v-1.1h17.776z",
    fill: "#fff"
  })));
};
export default SvgMyLorriesActive;